module.exports = __webpack_public_path__ + "static/media/GraphQL.7b929c0d.png";